import {pebble} from '../sass/base/_exports.sass';

export const BrokenImageIcon = (props) => {
  const {color = pebble, className = '', ratio = 1} = props;

  // default dimensions
  const width = 40.085;
  const height = 33.287;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      className={className}
    >
      <path
        fill={color}
        d="M34.157,10.937a1.279,1.279,0,0,0-1.066.546l-22.175,30.7a1.283,1.283,0,1,0,2.079,1.506l2.079-2.878h19.5a1.279,1.279,0,1,0,0-2.559H16.926l3.265-4.518,1.279.88a1.279,1.279,0,0,0,1.546-.08l9.835-8.262,7.676,6.53v5.45H38.781a1.279,1.279,0,1,0,0,2.559h3.025a1.279,1.279,0,0,0,1.279-1.279V15.655a1.279,1.279,0,0,0-1.279-1.279H34.17l1-1.386a1.279,1.279,0,0,0-1.013-2.052ZM4.146,14.375A1.279,1.279,0,0,0,3,15.655V39.535a1.279,1.279,0,0,0,1.279,1.279H8.131a1.279,1.279,0,1,0,0-2.559H5.559V35.378l8.529-5.81.853.586a1.281,1.281,0,1,0,1.439-2.119l-1.572-1.079a1.286,1.286,0,0,0-1.439,0l-7.809,5.33V16.934H25.228a1.279,1.279,0,1,0,0-2.559H4.279A1.281,1.281,0,0,0,4.146,14.375Zm28.172,2.559h8.209V29.447l-6.85-5.824a1.292,1.292,0,0,0-1.652,0L22.11,31.953l-.426-.293Zm-17.8,1.279a3.412,3.412,0,1,0,3.412,3.412A3.431,3.431,0,0,0,14.514,18.213Zm0,2.559a.853.853,0,1,1-.853.853A.834.834,0,0,1,14.514,20.772Z"
        transform="translate(-3 -10.937)"
      />
    </svg>
  );
};
